import * as angular from "angular";
import {IController} from "angular";

const FULLSCREEN_CHANGE_EVENTS = ['fullscreenchange', 'webkitfullscreenchange'];

export class MapPolygonDrawToolbarComponent implements IController {
  showDrawToolbar: boolean;
  showDeleteTool: boolean;
  showDrawCompleteTool: boolean;
  showRectangleTool: boolean;
  showPolygonTool: boolean;
  drawToolMode: string;
  onSelectHandTool: Function;
  onSelectRectangleTool: Function;
  onSelectPolygonTool: Function;
  onCompleteDraw: Function;
  onDeletePolygon: Function;

  private placeholder: Comment;
  private onFullscreenChange = () => this._syncFullscreenPlacement();

  constructor(private $element) {
  }

  $onInit() {
    FULLSCREEN_CHANGE_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, this.onFullscreenChange);
    });
  }

  $onDestroy() {
    FULLSCREEN_CHANGE_EVENTS.forEach((eventName) => {
      document.removeEventListener(eventName, this.onFullscreenChange);
    });
    this._restorePlacement();
  }

  // Google Maps fullscreen shows only the map div, so the toolbar has to live inside it while fullscreen is on
  private _syncFullscreenPlacement() {
    const toolbarElement: HTMLElement = this.$element[0];
    const fullscreenElement: Element = document.fullscreenElement || (document as any).webkitFullscreenElement;
    const homeElement: Element = this.placeholder ? this.placeholder.parentNode as Element : toolbarElement.parentElement;

    if (fullscreenElement && homeElement && homeElement.contains(fullscreenElement)) {
      if (!this.placeholder) {
        this.placeholder = document.createComment('map-polygon-draw-toolbar');
        toolbarElement.parentNode.insertBefore(this.placeholder, toolbarElement);
      }
      fullscreenElement.appendChild(toolbarElement);
    } else {
      this._restorePlacement();
    }
  }

  private _restorePlacement() {
    if (!this.placeholder) {
      return;
    }
    if (this.placeholder.parentNode) {
      this.placeholder.parentNode.insertBefore(this.$element[0], this.placeholder);
      this.placeholder.parentNode.removeChild(this.placeholder);
    } else {
      this.$element[0].remove();
    }
    this.placeholder = null;
  }
}

angular
  .module('bringoz.admin.map')
  .component('mapPolygonDrawToolbar', {
    bindings: {
      showDrawToolbar: '<',
      showDeleteTool: '<',
      showDrawCompleteTool: '<',
      showRectangleTool: '<?',
      showPolygonTool: '<?',
      drawToolMode: '<',
      onSelectHandTool: '&',
      onSelectRectangleTool: '&',
      onSelectPolygonTool: '&',
      onCompleteDraw: '&',
      onDeletePolygon: '&'
    },
    template: require('./map-polygon-draw-toolbar.html').default,
    controller: MapPolygonDrawToolbarComponent
  });
